import AddProductDialogOrig from "../../../../components/dialog/addProductDialog/AddProductDialog";

export default function AddProductDialog({
  isOpen, onClose, addingProduct, addedProducts, tabPosition
})  {

  return (
    <AddProductDialogOrig
      open={isOpen}
      onClose={onClose(null)}
      addProduct={(addProductData, part, price, _dispOrder) => {
        onClose({
          status: "SUBMITTED",
          product: {
            addingProduct: addProductData,
            tabPos: part,
            orderPrice: price
          }
        })();
      }}
      productData={addingProduct}
      tabPosition={tabPosition}
      addedProductList={addedProducts.map((p) => ({...p, priceDetailTypeId: p.orderTypeId}))}
      openAddProductMasterDialog={(product) => onClose({status: "ADD_PRODUCT_MASTER", product})()}
      openAddProductDetailMasterDialog={(product) => onClose({status: "ADD_PRODUCT_DETAIL_MASTER", product})()}
      priceTitle={"注文価格"}
      hideDisplayOrder
    />
  );
}
  